// @ts-nocheck
import useWidgetBadges from "@insite/client-framework/Common/Hooks/useWidgetBadges";
import { HasProductContext, withProductContext } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { VariantDisplayTypeValues } from "@insite/client-framework/Types/ApiModels";
import ProductAttributes, { ProductAttributesStyles } from "@insite/content-library/Components/ProductAttributes";
// import { ProductAvailabilityStyles } from "@insite/content-library/Components/ProductAvailability"; // Starter Custom Code
// import ProductBrand, { ProductBrandStyles } from "@insite/content-library/Components/ProductBrand"; // Starter Custom Code
import ProductContextAvailability from "@insite/content-library/Components/ProductContextAvailability";
// import ProductDescription, { ProductDescriptionStyles } from "@insite/content-library/Components/ProductDescription"; // Starter Custom Code
import ProductImageBadges from "@insite/content-library/Components/ProductImageBadges";
// import ProductPartNumbers, { ProductPartNumbersStyles } from "@insite/content-library/Components/ProductPartNumbers"; // Starter Custom Code
import ProductTextBadges from "@insite/content-library/Components/ProductTextBadges";
import ProductListVariantSwatch from "@insite/content-library/Widgets/ProductList/ProductListVariantSwatch";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

/* Starter Custom Code - Start */
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import {
    ProductAvailabilityStyles,
    useShowProductAvailability,
} from "@store/Overrides/Components/ProductAvailability";
import ProductBrand, { ProductBrandStyles } from "@store/Overrides/Components/ProductBrand";
import ProductDescription, { ProductDescriptionStyles } from "@store/Overrides/Components/ProductDescription";
import { ProductImageBadgesStyles } from "@store/Overrides/Components/ProductImageBadges";
import ProductPartNumbers, { ProductPartNumbersStyles } from "@store/Overrides/Components/ProductPartNumbers";
import { ProductTextBadgesStyles } from "@store/Overrides/Components/ProductTextBadges";
import { productCardProps } from "@store/Themes/common/props/productCard";
import mergeProps from "@toolkit/Framework/Common/Utilities/mergeProps";
import { useSettingsCollection } from "@toolkit/Framework/Store/Context/ContextHooks";
/* Starter Custom Code - End */

/* Store Custom Code */
import ProductPrice, { ProductPriceStyles } from "@insite/content-library/Components/ProductPrice";
import ProductQuantityBreakPricing, {
    ProductQuantityBreakPricingStyles,
} from "@insite/content-library/Components/ProductQuantityBreakPricing";
/* Store Custom Code */

interface OwnProps {
    showBrand: boolean;
    showTitle: boolean;
    showPartNumbers: boolean;
    showAvailability: boolean;
    showAttributes: boolean;
    showImageBadges?: boolean;
    maxImageBadges?: number;
    showTextBadges?: boolean;
    maxTextBadges?: number;
    // Store Custom Code
    showPrice?: boolean;
}

const mapStateToProps = (state: ApplicationState) => ({
    settingsCollection: getSettingsCollection(state),
});

type Props = ReturnType<typeof mapStateToProps> & OwnProps & HasProductContext;

export interface ProductListProductInformationStyles {
    container?: GridContainerProps;
    brandStyles?: ProductBrandStyles;
    descriptionStyles?: ProductDescriptionStyles;
    brandGridItem?: GridItemProps;
    descriptionGridItem?: GridItemProps;
    partNumbersGridItem?: GridItemProps;
    swatchGridItem?: GridItemProps;
    imageBadgeGridItem?: GridItemProps;
    textBadgeGridItem?: GridItemProps;
    partNumbersStyles?: ProductPartNumbersStyles;
    availabilityGridItem?: GridItemProps;
    availabilityStyles?: ProductAvailabilityStyles;
    attributesGridItem?: GridItemProps;
    attributes?: ProductAttributesStyles;
    searchScoreDataGridItem?: GridItemProps;
    // Starter Custom Code
    attributesWrapper?: InjectableCss;
    productTextBadges?: ProductTextBadgesStyles;
    productImageBadges?: ProductImageBadgesStyles;
    // Store Custom Code
    quantityBreakPricing?: ProductQuantityBreakPricingStyles;
    priceWrapper?: InjectableCss;
    price?: ProductPriceStyles;
}

export const productInformationStyles: ProductListProductInformationStyles = {
    brandStyles: productCardProps.brand,
    descriptionStyles: mergeProps<ProductListProductInformationStyles["descriptionStyles"]>(
        productCardProps.description,
        {
            wrapper: {
                forwardAs: "h2",
            },
        },
    ),
    attributesWrapper: productCardProps.spacingWrapper,
    partNumbersStyles: productCardProps.partNumbers,
    attributes: productCardProps.attributes,
    availabilityStyles: productCardProps.availability,
    productTextBadges: productCardProps.textBadges,
    productImageBadges: productCardProps.imageBadges,
    // Store Custom Code
    priceWrapper: productCardProps.spacingWrapper,
    price: productCardProps.price,
    quantityBreakPricing: productCardProps.quantityBreakPricing,
};

const styles = productInformationStyles;

const ProductListProductInformation = ({
    productContext,
    settingsCollection,
    showBrand,
    showTitle,
    showPartNumbers,
    showAvailability: baseShowAvailability, // Starter Custom Code
    showAttributes,
    showImageBadges,
    maxImageBadges,
    showTextBadges,
    maxTextBadges,
    // Store Custom Code
    showPrice,
}: Props) => {
    const showAvailability = useShowProductAvailability() && baseShowAvailability; // Starter Custom Code
    const { product } = productContext;
    if (!product) {
        return null;
    }

    const { imageBadges, textBadges } = useWidgetBadges({ productContext, showTextBadges, showImageBadges });

    let variantDisplayTrait = null;
    if (product.variantTraits && product.variantTraits.length > 0) {
        const swatchedViewList = [
            VariantDisplayTypeValues.SwatchDropdown,
            VariantDisplayTypeValues.SwatchList,
            VariantDisplayTypeValues.SwatchGrid,
        ];
        const sortedVaraintTraits = product.variantTraits.slice().sort((a, b) => a.sortOrder - b.sortOrder);
        variantDisplayTrait = sortedVaraintTraits.find(x => swatchedViewList.includes(x.displayType));
    }

    /* Store Custom Code - Start */
    const productSettings = settingsCollection.productSettings;
    /* Store Custom Code - End */

    /* Starter Custom Code - Start */
    return (
        <>
            {product.brand && showBrand ? (
                <ProductBrand brand={product.brand} extendedStyles={styles.brandStyles} />
            ) : null}
            {showTitle && <ProductDescription product={productContext} extendedStyles={styles.descriptionStyles} />}
            {showPartNumbers || showAttributes ? (
                <StyledWrapper {...styles.attributesWrapper}>
                    {showPartNumbers && (
                        <ProductPartNumbers
                            productNumber={product.productNumber}
                            customerProductNumber={product.customerProductNumber}
                            manufacturerItem={product.manufacturerItem}
                            extendedStyles={styles.partNumbersStyles}
                        />
                    )}
                    {showAttributes && (
                        <ProductAttributes maximumNumberAttributeTypes={3} extendedStyles={styles.attributes} />
                    )}
                </StyledWrapper>
            ) : null}
            {/* Store Custom Code - ProductContextAvailability moved below */}
            {variantDisplayTrait && (
                <ProductListVariantSwatch product={productContext} variantTrait={variantDisplayTrait} />
            )}
            {showTextBadges && textBadges && (
                <ProductTextBadges
                    badgeList={textBadges}
                    maxBadges={maxTextBadges ?? 4}
                    extendedStyles={styles.productTextBadges}
                />
            )}
            {showImageBadges && imageBadges && (
                <ProductImageBadges
                    badgeList={imageBadges}
                    maxBadges={maxImageBadges ?? 4}
                    extendedStyles={styles.productImageBadges}
                />
            )}
            {/* Store Custom Code - Start */}
            {showPrice && (
                <StyledWrapper {...styles.priceWrapper /* Starter Custom Code */}>
                    <ProductPrice
                        product={productContext}
                        showLabel={false}
                        showSavings={true}
                        showSavingsAmount={productSettings.showSavingsAmount}
                        showSavingsPercent={productSettings.showSavingsPercent}
                        extendedStyles={styles.price}
                    />
                    <ProductQuantityBreakPricing extendedStyles={styles.quantityBreakPricing} />
                </StyledWrapper>
            )}
            {showAvailability && <ProductContextAvailability extendedStyles={styles.availabilityStyles} />}
            {/* Store Custom Code - End */}
        </>
    );
    /* Starter Custom Code - End */
};

export default connect(mapStateToProps)(withProductContext(ProductListProductInformation));
